import { render, staticRenderFns } from "./approvalForm.vue?vue&type=template&id=0f2df1dc&scoped=true"
import script from "./approvalForm.vue?vue&type=script&lang=js"
export * from "./approvalForm.vue?vue&type=script&lang=js"
import style0 from "./approvalForm.vue?vue&type=style&index=0&id=0f2df1dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2df1dc",
  null
  
)

export default component.exports